// extracted by mini-css-extract-plugin
module.exports = {"container":"delivery_container__b15HN","title":"delivery_title__dQmoE","radioSelectItem":"delivery_radioSelectItem__il_HH","radioItemText":"delivery_radioItemText__rlccG"};